import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './IconBox.c.svg';

export const IconBox = withIconWrapper(ReactComponent);
